import { DataTableNew } from '@/design-system/data-table-new';
import { Inline } from '@/design-system/inline/inline';
import { Stack } from '@/design-system/stack/stack';
import { CardView } from '@/types/entity-types';
import {
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  PaginationState,
  useReactTable,
} from '@tanstack/react-table';
import { ReactNode, useState } from 'react';
import { cardsTableColumns } from './cards-table-column-definition';

type CardsTableProps = {
  cards: CardView[];
  onSelectCard?: (id: string) => void;
  onEditNickname?: (card: CardView) => void;
  onCancelCard?: (card: CardView) => void;
  toolbarActions?: ReactNode;
};

export const CardsTable = ({ cards, onSelectCard, onEditNickname, onCancelCard, toolbarActions }: CardsTableProps) => {
  const [pagination, setPagination] = useState<PaginationState>({ pageIndex: 0, pageSize: 20 });
  const [globalFilter, setGlobalFilter] = useState('');

  const table = useReactTable({
    data: cards,
    columns: cardsTableColumns,
    meta: { onEditNickname, onCancelCard },
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    onPaginationChange: setPagination,
    onGlobalFilterChange: setGlobalFilter,
    state: { pagination, globalFilter },
  });

  return (
    <Stack space={4}>
      <Inline align="center" justify="between" className="w-full">
        <DataTableNew.GlobalSearch table={table} placeholder="Search cards" />

        {toolbarActions}
      </Inline>

      <div className="overflow-hidden rounded-lg border border-border">
        <DataTableNew.Table
          table={table}
          onSelectRow={onSelectCard}
          noResultsMessage="No cards found"
          aria-label="Cards table"
        />
      </div>

      {table.getPageCount() > 1 && (
        <Inline align="center" justify="end">
          <DataTableNew.Pagination table={table} />
        </Inline>
      )}
    </Stack>
  );
};
